import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-alert-alcool',
  templateUrl: './alert-alcool.component.html',
  styleUrls: ['./alert-alcool.component.css']
})
export class AlertAlcoolComponent implements OnInit {

  innerHeight: number = window.innerHeight;

  currPoint: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public cssService : CssService,
    public dialogRef: MatDialogRef<AlertAlcoolComponent>,

  ) {
    this.currPoint = data.pointOfSale;
  }

  ngOnInit() {
  }

  closeDial(isMajor:boolean) {
    this.dialogRef.close(isMajor);
  }

}
